import { Form, Modal, Row, Col, Spinner } from "react-bootstrap";
import "./AddEditRoleMaster.css"

const ViewItemMaster = (props) => {
    const itemObj = props.rowdata;

    return (
        <>
            {/* {loading && <div className="spinner-box"> <Spinner animation="border" className="spinner" /></div>} */}
            <Modal
                {...props}
                size="lg"
                backdrop="static" centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {props.action} Item
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form
                        id="itemmaster"
                        name="itemmaster"
                    >
                        <Row >
                            <Col md={4} xs={12}>
                                <Form.Group className="g-input ">
                                    <div className="d-flex align-items-center">
                                        <Form.Control
                                            id="ItemCode"
                                            type="text"
                                            name="ItemCode"
                                            value={itemObj.ItemCode}
                                            readOnly />
                                        <Form.Label className="frm-label" for="ItemCode">Item Code</Form.Label>
                                    </div>
                                </Form.Group>
                            </Col>
                            <Col md={4} xs={12}>
                                <Form.Group className="g-input">
                                    <Form.Control
                                        id="ItemDescription"
                                        type="text"
                                        name="ItemDescription"
                                        value={itemObj.ItemDescription}
                                        readOnly
                                    />
                                    <Form.Label className="frm-label" for="ItemDescription">Item Description</Form.Label>
                                </Form.Group>
                            </Col>

                            <Col md={4} xs={12}>
                                <Form.Group className="g-input">
                                    <Form.Control
                                        id="ItemType"
                                        type="text"
                                        name="ItemType"
                                        value={itemObj.ItemType}
                                        readOnly
                                    />
                                    <Form.Label className="frm-label" htmlFor="ItemType">Item Type</Form.Label>
                                </Form.Group>
                            </Col>

                            <Col md={4} xs={12}>
                                <Form.Group className="g-input">
                                    <div className="d-flex align-items-center">
                                        <Form.Control
                                            id="ProductClass"
                                            type="text"
                                            name="ProductClass"
                                            value={itemObj.ProductClass}
                                            readOnly
                                        />
                                        <Form.Label className="frm-label" for="ProductClass">Product Class</Form.Label>
                                    </div>
                                </Form.Group>
                            </Col>

                            <Col md={4} xs={12}>
                                <Form.Group className="g-input">
                                    <div className="d-flex align-items-center">
                                        <Form.Control
                                            id="CommodityCodes"
                                            type="text"
                                            name="CommodityCodes"
                                            value={itemObj.CommodityCodes}
                                            readOnly
                                        />
                                        <Form.Label className="frm-label" for="CommodityCodes">Commodity Code</Form.Label>
                                    </div>
                                </Form.Group>
                            </Col>

                            <Col md={4} xs={12}>
                                <Form.Group className="g-input">
                                    <div className="d-flex align-items-center">
                                        <Form.Control
                                            id="LogisticCompany"
                                            type="text"
                                            name="LogisticCompany"
                                            value={itemObj.LogisticCompany}
                                            readOnly
                                        />
                                        <Form.Label className="frm-label" for="LogisticCompany">Logistic Company</Form.Label>
                                    </div>
                                </Form.Group>
                            </Col>

                        </Row>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default ViewItemMaster;
